<template>
  <login-wrap :text="isForcedLogin ? forcedMFAMessage : null">
    <valid-form @submit="loginAction">
      <qx-input-row
        id="user-password"
        v-model="password"
        :label="passwordLabel"
        :type="isPasswordVisible ? 'text' : 'password'"
        class="position-relative"
        rules="required|password"
        :autofocus="true"
        name="userPassword"
        autocomplete="password">
        <template #label-right>
          <div
            id="forgotPassword"
            class="qx-link"
            @click.prevent="onClickForgotPassword">
            {{ forgotLabel }}
          </div>
        </template>
        <template #icon>
          <visibility-button
            :visible="isPasswordVisible"
            @toggle-visibility="isPasswordVisible = !isPasswordVisible" />
        </template>
      </qx-input-row>

      <qx-button
        id="login"
        :is-block="true"
        :title="buttonLabel"
        :in-progress="inProgress"
        type="submit"
        state="active" />
    </valid-form>
    <another-account />
  </login-wrap>
</template>

<script>
import { Form as ValidForm } from 'vee-validate';

import { mapState, mapMutations } from 'vuex';

// Elements
import QxInputRow from '@/elements/QxInputRow.vue';
import qxButton from '@/elements/button.vue';
import VisibilityButton from '@/elements/form/VisibilityButton.vue';
import LoginWrap from '@/components/auth/LoginWrap.vue';
import anotherAccount from '@/elements/auth/anotherAccount.vue';

import { mfaLogin } from '@/api';
import { FORGOT_PASSWORD_CODE } from '@/utils/cons';
import { btoa } from '@/elements/utils';

export default {
  name: 'LoginPassword',
  components: {
    QxInputRow,
    qxButton,
    VisibilityButton,
    ValidForm,
    LoginWrap,
    anotherAccount,
  },
  emits: ['successLogin'],
  data() {
    return {
      inProgress: false,
      password: null,
      isPasswordVisible: false,
      passwordLabel: this.$gettext('Password'),
      buttonLabel: this.$gettext('Log in'),
      forgotLabel: this.$gettext('Forgot password') + '?',
      forcedMFAMessage: this.$gettext('MFA was activated by your administrator. Please log in to set it up') + '.',
    };
  },
  computed: {
    ...mapState({
      userEmail: (state) => state.auth.userEmail,
      loginError: (state) => state.auth.loginError,
      mfaCode: (state) => state.auth.mfaCode,
      isForcedLogin: (state) => state.auth.isForcedLogin,
    }),
  },
  watch: {
    loginError() {
      this.password = null;
    },
  },
  methods: {
    ...mapMutations({
      setMfaCode: 'auth/setMfaCode',
      setLoginError: 'auth/setLoginError',
    }),

    onClickForgotPassword() {
      this.setMfaCode(FORGOT_PASSWORD_CODE);
    },
    async loginAction() {
      if (this.inProgress) {
        return;
      }
      this.inProgress = true;

      try {
        const { status } = await mfaLogin({
          auth_type: 'basic_auth',
          code: btoa(this.password),
        });
        if (status === 200) {
          this.$emit('successLogin');
        }
      } catch (error) {
        Sentry.captureException(error);
        this.setLoginError('wrongPassword');
      } finally {
        this.inProgress = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#forgotPassword {
  font-size: 14px;
}
</style>
